import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalBody,
  Spinner,
} from 'reactstrap';

import LocaleService from '@services/LocaleService';
import { DownloadIcon } from '@shared/icons';

import './CustomDocumentViewerStyle.scss';

const i18n = LocaleService.getTranslations('general');
interface CustomDocumentViewerFunctions {
  show: (data: any) => void;
  hide: () => void;
}

export const CustomDocumentViewer: CustomDocumentViewerFunctions = {
  show: () => {
    // Your implementation here
  },
  hide: () => {
    // Your implementation here
  },
};

export const useCustomDocumentViewer = () => CustomDocumentViewer;

const CustomDocumentViewerComponent: React.FC = () => {
  const [ showModal, setShowModal ] = useState(false);
  const [ docs, setDocs ] = useState<any>([]);
  const [ showDownload, setShowDownload ] = useState(false);
  const [ loading, setLoading ] = useState(true);
  const [ downloading, setDownloading ] = useState(false);

  const confirmClose = () => {
    setShowModal(false);
    setDocs([
      {
        uri: '',
        fileType: 'docx',
        fileName: '',
        tempFilename: '',
        onDownload: null,
      },
    ]);
  };

  useEffect(() => {
    CustomDocumentViewer.show = (data: any) => {
      const newDocs = [
        {
          uri: data.url,
          fileType: data?.customFileType,
          fileName: data.filename,
          onDownload: data.onDownload,
          // s3Filename: data.s3Filename,
          // tempFilename: data.temp_filename,
        },
      ];

      setShowDownload(data.showDownload);
      setDocs(newDocs);
      setShowModal(true);
      setLoading(true);
    };
    CustomDocumentViewer.hide = () => confirmClose();
  }, []);

  if (!showModal) return null;

  return (
    <Modal
      isOpen={showModal}
      toggle={confirmClose}
      centered
      fullscreen
      className="document-modal"
    >
      <div className="d-flex align-items-center justify-content-between custom-header gap-2">
        <h5 className="mb-0 title flex-1">
          {docs[0].fileName}
        </h5>
        <div className="d-flex align-items-center gap-4">
          {
            (showDownload && docs[0].onDownload) && (
              <a
                href="#"
                aria-label="download-preview-template"
                className={classNames('download-button-style d-flex align-items-center gap-2')}
                onClick={async (e) => {
                  if (downloading) {
                    return;
                  }
                  e.preventDefault();
                  setDownloading(true);
                  // onDownload already wrapped with try/catch
                  await docs[0].onDownload();
                  setDownloading(false);
                }}
              >
                {downloading
                  ? <Spinner className="download-attachment-spinner" size="sm" color="#D9D9D9" />
                  : <DownloadIcon className="download-icon" />}
                <span className="download-text">{i18n.button.download.name}</span>
              </a>
            )
          }

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={confirmClose}
          />
        </div>
      </div>
      <ModalBody className={classNames('b2', {
        'pdf-viewer-active': docs[0]?.fileType === 'pdf' && true,
      })}
      >
        {loading && (
          <div className="doc-loader">
            <Spinner />
          </div>
        )}
        <iframe
          // key={key}
          // src={`https://docs.google.com/gview?url=${encodeURIComponent(docs[0].uri)}&embedded=true`}
          // src={`https://docs.google.com/viewer?url=${encodeURIComponent(docs[0].uri)}&embedded=true`}
          // src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(docs[0].uri)}`}
          src={docs[0].fileType === 'pdf'
            ? `https://docs.google.com/viewer?url=${encodeURIComponent(docs[0].uri)}&embedded=true`
            : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(docs[0].uri)}`}
          title="Document"
          frameBorder={0}
          width="100%"
          height="99%"
          // sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          onLoad={() => {
            setLoading(false);
            // clearInterval(timeoutInterval.current);
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default CustomDocumentViewerComponent;
